import { Services } from '@/services/services'
import { toLocalISOString, withReportsFromDay } from '@/common/time'
import { fetchExcel, fetchPDF } from '@/common/fetch'

export interface WizardData {
  from: Date
  to: Date
}

export const cleanWizardData = (): WizardData => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 0, 0);

  const empty: WizardData = {
    from: startOfToday,
    to: endOfToday,
  };

  return withReportsFromDay(empty)
}

export const checklistReportQuery = (wizardData: WizardData, lang?: string): string => {
  const params: Record<string, string> = {
    from: toLocalISOString(wizardData.from),
    to: toLocalISOString(wizardData.to),
  }
  if (lang) {
    params.lang = lang
  }
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
}

export const loadChecklistPDF = (services: Services, wizardData: WizardData, lang?: string) => {
  fetchPDF({
    url: `/api/communal/my/reports/checklist/pdf?${checklistReportQuery(wizardData, lang || 'en')}`,
    fileName: 'checklist.pdf',
    services
  })
}

export const loadChecklistExcel = (services: Services, wizardData: WizardData, lang?: string) => {
  fetchExcel({
    url: `/api/communal/my/reports/checklist/excel?${checklistReportQuery(wizardData, lang || 'en')}`,
    fileName: 'checklist.xlsx',
    services
  })
}
